module.exports = __webpack_public_path__ + "media/images/keep-away-from-light-38701e0fbaf253f20ab0c058a5a4c18a.svg";